import type { components } from '~/types/api';

export type CodedError = Pick<components['schemas']['CodedErrorResponse'], 'code' | 'message'>;

/**
 * Lê `{code, message}` de um corpo de erro qualquer. As recusas com código estável (escritório
 * suspenso, sem acesso, host desconhecido) chegam nessa forma; o resto (`{detail}`, erros por
 * campo, HTML de um proxy) devolve `null`.
 */
export function readCodedError(body: unknown): CodedError | null {
  if (typeof body !== 'object' || body === null) return null;
  if (!('code' in body) || typeof body.code !== 'string') return null;
  const message = 'message' in body && typeof body.message === 'string' ? body.message : '';
  return { code: body.code, message };
}
